// extracted by mini-css-extract-plugin
export default {"mainContainer":"withdrawalPage_mainContainer__CiG46"};